module.exports = __webpack_public_path__ + "static/media/NYLON 2.6cf0ef56.png";